import { render } from "./AccessibilitySectionHeader.vue?vue&type=template&id=2c64d223"
import script from "./AccessibilitySectionHeader.vue?vue&type=script&lang=js"
export * from "./AccessibilitySectionHeader.vue?vue&type=script&lang=js"

import exportComponent from "/Users/francoisgillet/Documents/GitHub/tenjity-module/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__